<template>
  <div
    :class="{
      'benefits-nr-fi': true,
      'benefits-nr-fi--boxed': box,
      'benefits-nr-fi--active': active,
    }"
    :style="boxStyle"
    :draggable
    @click="onClick"
  >
    {{ count }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { Box, PlaceholderProps } from './ProductBenefitsFi.vue';

const props = defineProps<{
  draggable?: boolean;
  dataSourceId: string | number;
  placeholderProps: PlaceholderProps;
  box?: Box;
}>();

const boxStyle = computed(() =>
  props.box
    ? {
        left: `calc(${props.box.left * 0.1}% - (var(--box-width) * 0.5))`,
        top: `calc(${props.box.top * 0.1}% - (var(--box-width) * 0.5))`,
      }
    : undefined,
);

const count: number = props.placeholderProps.benefitsCount[props.dataSourceId] || 0;

const active = computed<boolean>(
  () =>
    props.dataSourceId === props.placeholderProps.active ||
    (!props.placeholderProps.carousel &&
      (props.placeholderProps.active === null || props.placeholderProps.active === '')),
);

const onClick = () => {
  if (props.placeholderProps.active === props.dataSourceId) {
    props.placeholderProps.activate(null);
  } else {
    props.placeholderProps.activate(props.dataSourceId);
  }
};
</script>

<style src="./benefits-nr-fi" />
